import * as actionTypes from '../actionTypes/listings';

export default {
  setOrgListings: (params) => (dispatch) => {
    const actionData = { type: actionTypes.SET_ORG_LISTINGS, payload: params };
    dispatch(actionData);
  },
  updateListing: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_LISTING,
      payload: params,
    };
    dispatch(actionData);
  },
  updateOrgListings: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_ORG_LISTINGS,
      payload: params,
    };
    dispatch(actionData);
  },
  deleteOrgListing: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.DELETE_ORG_LISTING,
      payload: params,
    };
    dispatch(actionData);
  },
  updateOrgListingsApplicationNumbers: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_ORG_LISTINGS_APPLICATION_NUMBERS,
      payload: params,
    };
    dispatch(actionData);
  },
  addNewListing: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.ADD_NEW_LISTING,
      payload: params,
    };
    dispatch(actionData);
  },
  updateUnivListing: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPADTE_UNIV_LISTING,
      payload: params,
    };
    dispatch(actionData);
  },
};
